import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MasterNavbar from '../../../components/layout/MasterNavbar';
import { USERS_LIST_ENDPOINT, DELETE_USER_ENDPOINT } from '../../../utils/api';
import { useNavigate } from 'react-router-dom';
import { toast, Toaster } from 'react-hot-toast';

function UsersShow() {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  const fetchUsers = () => {
    axios.get(USERS_LIST_ENDPOINT)
      .then(res => setUsers(res.data.users || []))
      .catch(err => console.error('Failed to fetch users:', err));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleAddUser = () => {
    navigate('/users/add');
  };

const handleEdit = (userId, token) => {
  navigate(`/users/edit/${userId}/${token}`);

};

const handleDelete = async (userId, token) => {
  if (!window.confirm("Are you sure you want to delete this user?")) return;

  try {
    const res = await axios.post(DELETE_USER_ENDPOINT, {
      id: userId,
      master_user_token: token
    });

    if (res.data.success) {
      toast.success("User deleted");
      fetchUsers();
    } else {
      toast.error(res.data.message || "Failed to delete user");
    }
  } catch (err) {
    toast.error("Server error while deleting");
  }
};

  return (
    <>
      <MasterNavbar />
      <Toaster position="top-center" />
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">👥 Master Users</h4>
          <button className="btn btn-success" onClick={handleAddUser}>
            ➕ Add Master User
          </button>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Role</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">No users found.</td>
                </tr>
              ) : (
                users.map((user, index) => (
                  <tr key={user.id}>
                    <td>{index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.mobile}</td>
                    <td>{user.email}</td>
                    <td>{user.role || 'Master'}</td>
                    <td>
                      <div className="d-flex gap-2">
                      <button
  className="btn btn-primary btn-sm"
  onClick={() => handleEdit(user.id, user.master_user_token)}
>
  Edit
</button>

                       <button
  className="btn btn-danger btn-sm"
  onClick={() => handleDelete(user.id, user.master_user_token)}
>
  Delete
</button>

                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default UsersShow;
